import { useEffect, useState } from 'react';

import { Button } from '@/components/Shared/Button';
import { getCookieConsent, loadGoogleTagManager, setCookieConsent } from '@/utils';
import { CookiePreferencesModal } from './CookiePreferencesModal';

export const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);
  const [manageOpen, setManageOpen] = useState(false);
  const [functionalEnabled, setFunctionalEnabled] = useState(true);
  const [advertisingEnabled, setAdvertisingEnabled] = useState(true);

  useEffect(() => {
    const consent = getCookieConsent();
    if (consent) {
      setFunctionalEnabled(Boolean(consent.functional));
      setAdvertisingEnabled(Boolean(consent.advertising));
      if (consent.functional) loadGoogleTagManager();
    } else {
      setVisible(true);
    }
  }, []);

  // No advertising script (e.g. Meta Pixel) exists yet, so `advertising` is
  // stored but doesn't gate anything today — it will once one is added.
  const applyConsent = consent => {
    setCookieConsent(consent);
    setFunctionalEnabled(Boolean(consent.functional));
    setAdvertisingEnabled(Boolean(consent.advertising));
    if (consent.functional) loadGoogleTagManager();
    setVisible(false);
    setManageOpen(false);
  };

  const handleAcceptAll = () => applyConsent({ functional: true, advertising: true });
  const handleReject = () => applyConsent({ functional: false, advertising: false });

  return (
    <>
      {visible ? (
        <div className='fixed bottom-4 left-4 right-4 z-[1200] w-[calc(100%-2rem)] max-w-md mx-auto sm:right-auto animate-slide-up-cookies sm:animate-slide-in-left'>
          <div className='flex flex-col gap-4 p-6 bg-black  rounded-lg shadow-[0_10px_40px_-8px_rgba(0,0,0,0.55)]'>
            <p className='text-lg font-semibold font-baskervville text-white'>
              We use essential cookies to make this site work.
            </p>
            <p className='text-base font-outfit text-white/70'>
              With your permission, we also use optional cookies to understand
              how the site is used and to show you relevant marketing. You can
              change your choices at any time.
            </p>
            <div className='flex flex-wrap items-center gap-2'>
              <Button
                variant='contained'
                color='secondary.lightMintGreen'
                radius='4px'
                textColor='black'
                className='!font-baskervville !flex-1 !min-w-[90px]'
                onClick={handleAcceptAll}
              >
                Accept
              </Button>
              <Button
                variant='contained'
                color='secondary.lightMintGreen'
                radius='4px'
                textColor='black'
                className='!font-baskervville !flex-1 !min-w-[90px]'
                onClick={handleReject}
              >
                Reject
              </Button>
              <Button
                variant='contained'
                color='secondary.lightMintGreen'
                radius='4px'
                textColor='black'
                className='!font-baskervville !flex-1 !min-w-[90px]'
                onClick={() => setManageOpen(true)}
              >
                Manage
              </Button>
            </div>
          </div>
        </div>
      ) : null}

      <CookiePreferencesModal
        open={manageOpen}
        functionalEnabled={functionalEnabled}
        advertisingEnabled={advertisingEnabled}
        onClose={() => setManageOpen(false)}
        onSave={applyConsent}
      />
    </>
  );
};
